import { ProductCatalogApiClient } from '@fourthwall/services/dist/ProductCatalogApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useCatalogProductQuery = createQueryHook(ProductCatalogApiClient.getProduct, {
  queryKey: ['catalogProduct'],
})
